export enum PolizaStatus {
    EN_REVISION = 'EN_REVISION',
    ACEPTADA_VIGENTE = 'ACEPTADA_VIGENTE',
    VENCIDA = 'VENCIDA',
    RECHAZADA = 'RECHAZADA'
}
